// 閲覧履歴。商品ページを開くたびに商品 ID を Cookie「productLog」（JSON 配列）の末尾へ積む。
// 読み手は wuSiteResource2 の Shared/EcSiteForm.ts（お問い合わせフォームの「閲覧した商品」欄。
// Cookie の文字列をそのまま API に渡す）なので、★名前・形・path を変えない。
//
// あんしんや(2) はおちゃのこ「アクセス解析タグ設定」欄の直書きから引き取った（Issue #53）。
// 旧実装は jQuery.cookie（v1.4.1: 値を encodeURIComponent、有効期限なし = セッション Cookie、path=/）
// で書いていたので、同じ形で書く。他の店は wuSiteResource2 の各店 ProductDetails.ts が
// Shared/Cookie.ts（同じ encode、max-age 20 分、一度でも見た商品は積まない）で書いていた。
// b-futou(10) はそこから引き取った（Issue #70 追記）。形はこちら（末尾と違えば積む・セッション Cookie）に揃える。
// 対象店は shared/hooks.ts の PRODUCT_LOG_SITES。
//
// 商品 ID はおちゃのこのページが出しているグローバル pConf.productId（文字列）。無ければ何もしない
// （旧実装も try/catch で握り潰していた）。

export const PRODUCT_LOG_COOKIE = 'productLog'

export function readCookie(name: string, cookie: string = document.cookie): string | null {
  const m = cookie.match('(?:^|; )' + name + '=([^;]*)')
  if (!m) return null
  try {
    return decodeURIComponent(m[1].replace(/\+/g, ' '))
  } catch {
    return null
  }
}

/**
 * 現在の Cookie 値（JSON 文字列）に productId を積んだ配列を返す。
 * 末尾が同じ商品なら積まない（同じ商品をリロードしても増えない）ので、そのときは null。
 * 壊れた JSON は空配列から始める（旧実装どおり）。
 */
export function nextProductLog(current: string | null, productId: string): string[] | null {
  let array: unknown[] = []
  if (current != null) {
    try {
      const parsed: unknown = JSON.parse(current)
      if (Array.isArray(parsed)) array = parsed
    } catch {
      /* 旧実装どおり、読めなければ空から */
    }
  }
  // 旧実装は != で比べていた（'485' と 485 を同じ扱い）。文字列に揃えて比べる
  if (array.length > 0 && String(array[array.length - 1]) === String(productId)) return null
  return [...array.map(String), String(productId)]
}

export default function productLog(): void {
  const raw = (window as unknown as { pConf?: { productId?: unknown } }).pConf?.productId
  if (raw == null || raw === '') return
  const next = nextProductLog(readCookie(PRODUCT_LOG_COOKIE), String(raw))
  if (!next) return
  document.cookie = `${PRODUCT_LOG_COOKIE}=${encodeURIComponent(JSON.stringify(next))}; path=/`
}
